import axios from "axios";
import config from "../../../settings/config";
import { handleError } from "../../../network/servicErrorHandling";

async function account(uid) {
  return Promise.resolve().then((v) =>
    axios
      .get(`${config.baseUrl}v1/shops/${uid}/account`)
      .then((res) => {
        return res.data;
      })
      .catch((err) => {
        if (
          err.response &&
          err.response.status &&
          err.response.status === 404
        ) {
          localStorage.removeItem("selected_shop");
          window.location.href = "/";
        } else {
          handleError(err);
        }
      })
  );
}

export { account };
